import { useTranslation } from 'react-i18next';
import { useFormatTimeInterval } from './format-time';
import { units } from './units';

export const useParseTimeInterval = (
  hideSingular = false,
  { exact = false }: { exact?: boolean } = {},
) => {
  const formatTimeInterval = useFormatTimeInterval();

  const parseTimeInterval = (value: string) => {
    const ms = parseInt(value);

    const entries = Object.entries(units).reverse() as [
      keyof typeof units,
      number,
    ][];

    for (const [unit, unitMs] of entries) {
      // Selectors must label the actual duration, not a rounded larger unit.
      if (ms >= unitMs && (!exact || ms % unitMs === 0)) {
        const amount = Math.floor(ms / unitMs);

        if (amount === 1 && hideSingular) {
          return { ...formatTimeInterval(amount, unit), label: '' };
        }

        return formatTimeInterval(amount, unit);
      }
    }

    return { label: '', value: String(value), amount: 0, unit: null };
  };

  return parseTimeInterval;
};

export const usePluralizedLabel = (hideSingular: boolean = false) => {
  const { t } = useTranslation();

  const getLabel = (count: number, getUnitKey: (count: number) => string) => {
    const unitKey = getUnitKey(count);

    let keySuffix: string;
    if (count === 1) {
      if (hideSingular) {
        return '';
      }
      keySuffix = 'one';
    } else if (count >= 2 && count <= 4) {
      keySuffix = 'few';
    } else if (count >= 5 && count <= 20) {
      keySuffix = 'many';
    } else {
      keySuffix = 'other';
    }
    return t(`${unitKey}.${keySuffix}`, { count });
  };

  return getLabel;
};